// extracted by mini-css-extract-plugin
export default {"main":"CursoSelector_main__xYBiR"};